import React, { FC, useCallback, useEffect, useMemo, useState } from 'react';

import { useWizard, WizardStep } from '../../../contexts/WizardContext';

import Layout from '../../Layout';
import SelectBox from '../../shared/select-boxes/SelectBox';
import VideoComponent from '../../shared/VideoComponent';
import ButtonBack from '../../shared/buttonComponents/ButtonBack';
import LicencesPopupList from './LicencePopupList';
import { Licence } from '../../../api/static-data';
import { useHistory } from 'react-router-dom';

const noLicense: Licence = {
  name: 'No License',
  country: '-',
  category: '-',
  risk: '-'
};

export const LicencePopupListPage: FC = () => {

  const [selected, setSelected] = useState<string>('');

  const {
    changeStep,
    updateStepData,
    staticData,
  } = useWizard();

  const euCountriesMap = useMemo(() => staticData.countries
      .reduce((map, country) => {
        if (country.continent === 'Europe') {
          return {
            ...map,
            [country.name]: true
          };
        }

        return map;
      }, {} as { [key: string]: boolean })
    , [staticData.countries]);


  const euLicences: Licence[] = useMemo(() => {
    const licenses = staticData.licenses
      .filter((licence) => euCountriesMap[licence.country]);

    return [...licenses, noLicense];
  }, [staticData.licenses, euCountriesMap]);

  const nonEuLicences: Licence[] = useMemo(() => {
    const licenses = staticData.licenses
      .filter((licence) => !euCountriesMap[licence.country]);

    return [...licenses, noLicense];
  }, [staticData.licenses, euCountriesMap]);

  const handleSubmit = useCallback((licence: Licence) => {
    updateStepData({
      licence: licence.name,
      licenceRisk: licence.risk,
    });
    setSelected('');
    changeStep(WizardStep.COMPANY_TYPE);
  }, [updateStepData, setSelected, changeStep]);

  let history = useHistory();

  useEffect(() => {

    return () => {
      if (history.action === 'POP') {

        changeStep(WizardStep.INDUSTRY);
      }
    };
  });

  return (
    <Layout>
        {selected && (
          <LicencesPopupList
            licenceList={selected === 'EU' ? euLicences : nonEuLicences}
            onClose={() => setSelected('')}
            onSubmit={handleSubmit}
            title={selected === 'EU' ? 'EU' : 'Non-EU'}
          />
        )}
      <div className="licence-page-container">


        <div className="licence-type-page-right-mobile">
          <VideoComponent
            src={`${process.env.PUBLIC_URL}/assets/videos/license.webm`}
            fallbackImage={`${process.env.PUBLIC_URL}/assets/images/pages/license.png`}
          />
        </div>

        <div className="licence-type-page-left">
          <div className="secondary-title">Noted, we can support your Financial Services/Forex...</div>
          <div className="secondary-title-mobile">Noted, we can support your<br/>Financial Services/Forex...</div>
          <div className="main-title">And your<br/> license type?</div>


          <div className="licence-type-page-list">

            <SelectBox
              key={'licence'}
              onClick={() => setSelected('EU')}
              title='EU Licenses'
              icon='EU-D'
            />

            <SelectBox
              key={'no-licence'}
              onClick={() => setSelected('Non-EU')}
              title="Non EU Licenses"
              icon='Non-EU-D'
            />
          </div>
        </div>

        <div className="licence-type-page-right">
          <VideoComponent
            src={`${process.env.PUBLIC_URL}/assets/videos/license.webm`}
            fallbackImage={`${process.env.PUBLIC_URL}/assets/images/pages/license.png`}
          />
        </div>

      <div className='license-page-button'>
        <ButtonBack
          disabled={false}
          onClick={() => changeStep(WizardStep.INDUSTRY)}
          title="Back"
        />
      </div>
      </div>


    </Layout>
  );
};
